// Shared WebRTC helpers for Tap In TV live streams + conference rooms.
// Single source of truth for PeerConnection config + WS signaling construction.

import api from "./api";

let _iceCache = null;
let _iceExpires = 0;

export async function fetchIceServers() {
  const now = Date.now();
  if (_iceCache && _iceExpires > now) return _iceCache;
  try {
    const { data } = await api.get("/webrtc/ice-servers");
    _iceCache = data?.iceServers || [{ urls: ["stun:stun.l.google.com:19302"] }];
    _iceExpires = now + 45 * 60 * 1000; // refresh every 45m
    return _iceCache;
  } catch {
    return [{ urls: ["stun:stun.l.google.com:19302"] }];
  }
}

export function makeWsUrl(path) {
  // /api/ws/stream/... on backend, exposed through the same ingress host as REST
  const base = process.env.REACT_APP_BACKEND_URL;
  const httpBase = (base || window.location.origin).replace(/\/+$/, "");
  const wsBase = httpBase.replace(/^https:/, "wss:").replace(/^http:/, "ws:");
  return `${wsBase}${path}`;
}

export function newPeerConnection(iceServers) {
  return new RTCPeerConnection({
    iceServers: iceServers || [{ urls: ["stun:stun.l.google.com:19302"] }],
    iceTransportPolicy: "all",
    bundlePolicy: "max-bundle",
    rtcpMuxPolicy: "require",
  });
}
